import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

export type TitleBadgeColor =
  | 'orange'
  | 'sky'
  | 'purple'
  | 'blue'
  | 'green'
  | 'red'
  | 'deep-green'
  | 'deep-blue'

const colorClass = (color: TitleBadgeColor) => {
  switch (color) {
    case 'orange':
      return 'bg-fill-selected-kaki'
    case 'sky':
      return 'bg-fill-brand-badge'
    case 'purple':
      return 'bg-fill-selected-purple'
    case 'blue':
      return 'bg-fill-selected-blue'
    case 'green':
      return 'bg-fill-selected-green'
    case 'red':
      return 'bg-fill-selected-red'
    case 'deep-green':
      return 'bg-fill-selected-deep-green'
    case 'deep-blue':
      return 'bg-fill-selected-deep-blue'
  }
}

interface Props extends ChildProps {
  iconType: IconType
  color: TitleBadgeColor
}

const TitleBadge = ({ children, iconType, color }: Props) => {
  return (
    <span
      className={clsx('inline-flex items-center gap-1 rounded-[80px] px-3 py-1', colorClass(color))}
    >
      <Icon color={IconColor.ON_COLOR} type={iconType} />
      <Text color={TextColor.ON_BG_FILL} weight='bold'>
        {children}
      </Text>
    </span>
  )
}

export default TitleBadge
